import { IPS_DAYS } from './ipsConstants';

export function formatDateInput(date = new Date()) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function getDayKeyFromDate(dateStr) {
  if (!dateStr) return IPS_DAYS[0].key;
  const [y, m, d] = dateStr.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  const dayIndex = date.getDay();
  return IPS_DAYS[dayIndex === 0 ? 6 : dayIndex - 1].key;
}

export function getDayLabelFromDate(dateStr) {
  const key = getDayKeyFromDate(dateStr);
  return IPS_DAYS.find((day) => day.key === key)?.label || '';
}

export function getWeekStartMonday(dateStr) {
  if (!dateStr) return formatDateInput();
  const [y, m, d] = dateStr.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  const day = date.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  date.setDate(date.getDate() + diff);
  return formatDateInput(date);
}

export function formatDateLabel(dateStr) {
  if (!dateStr) return '';
  try {
    const [y, m, d] = dateStr.split('-').map(Number);
    return new Date(y, m - 1, d).toLocaleDateString('tr-TR', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  } catch {
    return dateStr;
  }
}

export function formatDateFullLabelLines(dateStr) {
  if (!dateStr) return { line1: '', line2: '' };
  try {
    const [y, m, d] = dateStr.split('-').map(Number);
    const date = new Date(y, m - 1, d);
    const monthName = date.toLocaleDateString('tr-TR', { month: 'long' });
    const weekday = getDayLabelFromDate(dateStr);
    return {
      line1: `${d} ${monthName}`,
      line2: `${weekday} ${y}`
    };
  } catch {
    return { line1: dateStr, line2: '' };
  }
}

export function formatDateFullLabel(dateStr) {
  if (!dateStr) return '';
  const { line1, line2 } = formatDateFullLabelLines(dateStr);
  return `${line1} ${line2}`;
}

/** Örn. 23.06.2026 salı */
export function formatDateWithWeekday(dateStr) {
  if (!dateStr) return '';
  try {
    const [y, m, d] = dateStr.split('-').map(Number);
    const dd = String(d).padStart(2, '0');
    const mm = String(m).padStart(2, '0');
    const weekday = getDayLabelFromDate(dateStr).toLocaleLowerCase('tr-TR');
    return `${dd}.${mm}.${y} ${weekday}`;
  } catch {
    return dateStr;
  }
}
